export default __webpack_public_path__ + "3da34c3ef3d6e478edf05f5c3c4b8a75.svg";